/*
 * careersAction.js
 * trt_cms2
 *
 * Created by Hisyam on 27/2/2020.
 * Copyright (c) 2020 Terato Tech. All rights reserved.
 */

import {
  ADD_CAREER,
  ADD_CAREER_FULFILLED,
  DELETE_CAREER,
  DELETE_CAREER_FULFILLED,
  FETCH_CAREER,
  FETCH_CAREER_FULFILLED,
  FETCH_CAREERS,
  FETCH_CAREERS_FULFILLED,
  NEW_CAREER,
  NEW_CAREER_FULFILLED,
  RESET_REDIRECT_CAREER,
  UPDATE_CAREER,
  UPDATE_CAREER_FULFILLED
} from "../types";
import {ofType} from "redux-observable";
import {catchError, debounceTime, map, mapTo, switchMap, tap, withLatestFrom} from "rxjs/operators";
import {CAREER_CATEGORIES_API, CAREERS_API} from "../../config/api";
import {apiHeader, encodeQueryData} from "../../config/helper";
import {forkJoin, of} from "rxjs";
import {ajax} from "rxjs/ajax";
import {returnErrors} from "../messages/messagesAction";

export const fetchCareers = (limit, offset, params) => ({type: FETCH_CAREERS, payload: {limit: limit, offset: offset, ...params}});
const fetchCareersFulfilled = (payload) => ({type: FETCH_CAREERS_FULFILLED, payload: payload});
export const fetchCareersEpic = (action$, state$) => action$.pipe(
  ofType(FETCH_CAREERS),
  debounceTime(500),
  withLatestFrom(state$),
  switchMap(([action, state]) => ajax.getJSON(CAREERS_API + `?${encodeQueryData(action.payload)}`, apiHeader(state)).pipe(
    map(response => fetchCareersFulfilled(response)),
    catchError(({response, status}) => of(returnErrors(response, status)))
  ))
);

export const newCareer = () => ({type: NEW_CAREER});
const newCareerFulfilled = payload => ({type: NEW_CAREER_FULFILLED, payload: payload});
export const newCareerEpic = (action$, state$) => action$.pipe(
  ofType(NEW_CAREER),
  withLatestFrom(state$),
  switchMap(([action, state]) => ajax.getJSON(CAREER_CATEGORIES_API, apiHeader(state))
    .pipe(
      map(response => newCareerFulfilled(response)),
      catchError(({response, status}) => of(returnErrors(response, status)))
    )
  )
);

export const fetchCareer = (id) => ({type: FETCH_CAREER, payload: id});
const fetchCareerFulfilled = payload => ({type: FETCH_CAREER_FULFILLED, payload: payload});
export const fetchCareerEpic = (action$, state$) => action$.pipe(
  ofType(FETCH_CAREER),
  withLatestFrom(state$),
  switchMap(([action, state]) => forkJoin({
    career: ajax.getJSON(CAREERS_API + `${action.payload}/`, apiHeader(state)),
    categories: ajax.getJSON(CAREER_CATEGORIES_API, apiHeader(state)),
  }).pipe(
    map((response) => fetchCareerFulfilled(response)),
    catchError(({response, status}) => of(returnErrors(response, status)))
  )),
);

export const addCareer = (career) => ({type: ADD_CAREER, payload: career});
const addCareerFulfilled = (payload) => ({type: ADD_CAREER_FULFILLED, payload: payload});
export const addCareerEpic = (action$, state$) => action$.pipe(
  ofType(ADD_CAREER),
  debounceTime(500),
  withLatestFrom(state$),
  switchMap(([action, state]) => ajax.post(CAREERS_API, action.payload, apiHeader(state))
    .pipe(
      map(({response}) => addCareerFulfilled(response)),
      catchError(({response, status}) => of(returnErrors(response, status)))
    )
  )
);

export const updateCareer = (id, career) => ({type: UPDATE_CAREER, payload: career, id: id});
const updateCareerFulfilled = (payload) => ({type: UPDATE_CAREER_FULFILLED, payload: payload});
export const updateCareerEpic = (action$, state$) => action$.pipe(
  ofType(UPDATE_CAREER),
  debounceTime(500),
  withLatestFrom(state$),
  switchMap(([action, state]) => ajax.put(CAREERS_API + `${action.id}/`, action.payload, apiHeader(state))
    .pipe(
      map(({response}) => updateCareerFulfilled(response)),
      catchError(({response, status}) => of(returnErrors(response, status)))
    )
  )
);

export const deleteCareer = id => ({type: DELETE_CAREER, id});
const deleteCareerFulfilled = id => ({type: DELETE_CAREER_FULFILLED, id});
export const deleteCareerEpic = (action$, state$) => action$.pipe(
  ofType(DELETE_CAREER),
  debounceTime(500),
  withLatestFrom(state$),
  switchMap(
    ([action, state]) => ajax.delete(CAREERS_API + `${action.id}/`, apiHeader(state))
      .pipe(
        map(() => deleteCareerFulfilled(action.id)),
        catchError(({response, status}) => of(returnErrors(response, status)))
      )
  )
);

export const resetRedirectCareerEpic = action$ => action$.pipe(
  ofType(ADD_CAREER_FULFILLED, UPDATE_CAREER_FULFILLED, DELETE_CAREER_FULFILLED),
  mapTo({type: RESET_REDIRECT_CAREER})
);